// TODO replace with native <dialog> (as modal or not) (+ polyfill https://github.com/GoogleChrome/dialog-polyfill )
// or replace with https://github.com/gdias/popinGen/blob/master/src/jquery.popinGen.js
/*
*   Plugin jQuery | Pop-in Manager
*   Made easy Pop-in Or Layer with jQuery
*
*   Copyright FNAC SA 2014
*   Developped by Guillaume DIAS
*   gdias@fnac.com
*
*/

import {isMobile} from "../common/others/Configuration";
import $ from "jquery";

  var pluginName = "popinManager",
    base,
    defaults = {
      selector: null,                                 // [Required] selecteur CSS l'élément déclencheur du plugin (bouton, lien, etc.). Peut être multiple
      idElem: "",                                     // [Paramètre interne] de gestion de l'id dynamique de la popin à partir de la classe utilisée
      idLayer: "layerPopin",                          // ID du layer transparent en mode pop-in
      targetContent: "",                              // [Required] CSS selector de la pop-in/layer, doit être un seul selecteur d'ID
      eventStart: "click",                            // evenement par defaut pour ouvrir la pop-in/layer
      eventStop: "",                                  // Evenement par defaut pour cacher la pop-in/layer : Si mouseenter sur eventStart, mouseleave auto
      modeView: "popin",                              // Mode de sélection d'affichage ("popin" = layer transparent + pop-in) et ("layer" = only layer)
      ajaxMode: false,                                // Mode de contenu AJAX
      ajaxMethod: function (el, popin, options) { },  // Methode ajax de remplissage de la pop-in; el = targetContent
      ajaxCharsSplit: "¤",                    // Charactère de split (par defaut Fnac) : si param vide, pas de split !
      ajaxLoaderLink: "",                             // Lien du gif animé pour le visuel du loader
      timer: 0,                                       // Timer de déclenchement de la pop-in/layer (utile pour les survols trop rapides)
      callbackMethod: function (el, popin, options) { },                // Méthod de CallBack si besoin (s'intègre dans le callback WebFormDoCallBack); el = eventStart element
      callbackMethodAfterCreate: function (el, popin, options) { },     // Méthode de callback sans ajax (uniquement lorsqu'on a pas d'ajax mais besoin d'un callback); el = eventStart element
      callbackMethodOpen: function (el, popin, options) { },            // Méthode Callback sans ajax (appelée à chaque ouverture de la pop-in); el = eventStart element
      callbackMethodClose: function (el, popin, options) { },           // Méthode appelée à la fermeture du layer (mode popin); el = popin.element or eventStart element (!?)
      closeOnLayer: true,                             // Permet de fermer le layer transparent + pop-in en cliquant sur le layer transparent (uniquement en mode popin)
      customPosition: false,                          // Permet de positionner le layer depuis l'élément qui l'affiche (uniquement en mode layer)
      relativePosition: { left: -1, top: -1 },        // Permet de positionner le layer comme on veut exactement !
      multiContent: false,                            // Permet de relancer la méthode ajax [ajaxMethod] sur chaque élément ayant la même classe css (donc le même div de destination)
      autoclose: false,                               // Permet de déclencher la fermeture automatique de la popin/layer
      timeToAutoclose: 3000,                          // Temps (en ms) de la fermeture automatique
      bindKeys: false,                                // Permet de fermer la pop-in avec la touche echap
      notBackButton: "",                              // (ID input hidden) permet de controler le bouton "page précédente" (utile lors d'ouverture de pop-in auto)
      scrollPopin: true,                              // Permet à la popin de suivre le scroll (true-false)
      backgroundLayerColor: "rgba(11, 11, 11, .8)",  // Détermine la couleur du layer
      prefixID: "containerPopin_",                    // Prefix ID auto construct for Auto generated <div/>
      classContainer: "",                             // Permet d'ajouter une classe sur la DIV générée
      fullscreen: false,                              // Permet de positionner au top et débrayer la limite de 30px min en hauteur
      toggle: false,                                  // Permet de d'inverser l'event lors d'un meme event.
      outerClose: false,                              // [layer only] Permet de fermer le layer quand on clique en dehors du layer
      groupBy: "",                                    // [Toggle obligatoire] Permet de définir un élément parent pour le toggle s'applique sur tous les éléments du groupe
      antiHeaderSticky: false,                        // [Layer obligatoire] Permet de controler la position du layer, avec des header sticky
      zIndex: 10045                                   // Permet de modifier le z-index attribué automatiquement au conteneur de la popin/layer.
    };

  function Plugin(options) {

    this.element = $(options.selector);
    this.options = $.extend({}, defaults, options);

    this._defaults = defaults;
    this._name = pluginName;
    this.layerID = "#" + this.options.idLayer;

    base = this;
    this.init();
  }

  Plugin.prototype = {

    init: function () {

      // block popin if click on backButton
      if (this.options.notBackButton) {
        var idNotBackButton = (this.options.notBackButton.indexOf("#") === -1) ? "#" + this.options.notBackButton : this.options.notBackButton;
        var inputVal = $(idNotBackButton).val();

        if (parseInt(inputVal) != 0) { return false; }
        $(idNotBackButton).val(1);
      }

      this.hideClassControl();

      if (this.options.modeView !== "layer") // create grey layer
        this.generateLayer(this.element, this.options)

      this.bindEvents(this.element, this.options); // binding events
    },
    bindEvents: function (el, options) {
      var timeEventStop, timeEventStart, $selector;

      function fnStart(event, elemCurrent) {

        var orginEvt = (!event.originalEvent) ? "trigger" : event.originalEvent.type;
        $selector = $(elemCurrent);

        base.generateContainer(elemCurrent, options);

        if (options.modeView === "layer") {

          if (options.groupBy != "" && options.toggle && orginEvt === options.eventStart) { // controle la présence d'un layer déjà ouvert dans le groupe
            var parent = $(options.groupBy);
            var typeElement = $(options.selector, parent).get(0).tagName;
            var alreadyOpenIndex;
            var hasClassOnTarget = options.selector.substring(1, options.selector.length);

            $(typeElement, parent).each(function (i) {
              if ($(this).data("alreadyOpen")) {
                if (elemCurrent !== $(this).get(0)) { // if toggle
                  $(this).data("alreadyOpen", false);
                  $("body").trigger("close");
                }
              }
            });
          }

          if ($selector.data("alreadyCreate")) {
            base.popinPosition(elemCurrent, options);
          }

          if (!$selector.data("alreadyOpen") && orginEvt === options.eventStart) {
            base.showPopinContent(elemCurrent, options);

            if (options.toggle && options.modeView === "layer") {
              $selector.data("alreadyOpen", true);
              if (options.outerClose) {
                $(options.idElem).focus();
              }
            }

            if (options.antiHeaderSticky && options.modeView === "layer") {
              setTimeout(function () {
                base.popinPosition(elemCurrent, options);
              }, 10);
            }


          } else {
            $selector.data("alreadyOpen", false);
            base.hidePopinAndLayer(el, options);
          }

        } else { // mode Popin

          if (options.fullscreen)
            $("body").css("overflow", "hidden");

          base.showTransparencyLayer();
          base.showPopinContent(elemCurrent, options); // show popin/layer
        }
        options.callbackMethodOpen(elemCurrent, base, options);
      }

      if (options.eventStart === "click" && options.modeView === "layer" && options.outerClose && !isMobile) {// replace click by mousedown pour le mode layer / outerClose --- and device is not touch
        options.eventStart = "mousedown";
        $(options.selector).click(function (e) { e.preventDefault(); }); // block click event
      }


      //$("html").on(options.eventStart, options.selector, function (e) {
      $(options.selector).on(options.eventStart, function (e) {
        e.preventDefault(); // for a element
        e.stopImmediatePropagation(); // for button element

        var element = this;

        if (options.timer > 0)
          timeEventStart = setTimeout(fnStart, options.timer, e, element);
        else
          fnStart(e, element);

        clearTimeout(timeEventStop); // clear time event stop

        if (options.autoclose) {
          setTimeout(function () {
            base.hidePopinAndLayer(el, options);
          },
            options.timeToAutoclose);
        }

      });


      if (options.closeOnLayer && options.modeView !== "layer") {

        var containerId = base.generatedId(options);

        var outerClickSelector = "#" + containerId + ", #" + options.idLayer;

        $("body").on("click", outerClickSelector, function (e) {

          if (e.target === this) {
            e.stopPropagation();
            e.preventDefault();
            base.hidePopinAndLayer(el, options)
          };
        });
      }

      // Event leaveHandler (if mouseenter like event)
      if (options.eventStart === "mouseenter" && options.modeView === "layer") {
        $("body").on(
          "mouseleave",
          options.selector,
          function () {
            clearTimeout(timeEventStart); // clear time event start
            timeEventStop = setTimeout(
              function () { // time event stop hover
                base.hidePopinAndLayer(el, options);
              }, parseInt(base.options.timer / 2, 10)
            );
          }
        );

        options.eventStop = "mouseleave";

        $("body").on(
          "mouseenter",
          options.targetContent,
          function () {
            clearTimeout(timeEventStop);
          }
        );
      }

      // Event leaveContent
      if (options.eventStop !== "") {
        // Event hide layer + popin during mouse out pop-in
        $("body").on(
          base.options.eventStop,
          base.options.targetContent,
          function (e) {
            e.preventDefault();
            timeEventStop = setTimeout(
              function () { // time event stop hover
                base.hidePopinAndLayer(el, options);
              },
              base.options.timer
            );
          }
        );
      }

      // Events close
      $("html").on("close", "body", function (e) {
        e.preventDefault();
        base.hidePopinAndLayer(el, options);
      });

      $("body").on("click", ".close", function (e) {
        e.preventDefault();
        //base.hidePopinAndLayer(el, options);
        $(this).trigger("close");
      });

      // Events refresh position
      $("html").on("refresh", "body", function (e) {
        e.preventDefault();
        base.popinPosition(el, options);
      });

      // Binding Event KEY for close popin
      if (options.bindKeys && options.modeView !== "layer") {
        $(window).on("keyup", document, function (e) {
          e.preventDefault();
          if (e.keyCode === 27) { // Escape key
            $("body").trigger("close"); // trigger close
          }
        });
      }
    },
    bindFocusBlurEvents: function (el, options) {
      var $selector;

      if (options.outerClose && options.toggle && options.modeView === "layer") {

        $selector = $(options.selector);

        if (el.tagName.toLowerCase() !== "input") { // if not input, for a tag ex.
          $(el).attr("tabindex", "-1");
        }

        $("body").on("focus", options.idElem, function (e) {
          e.preventDefault();
          $(this).css("outline", "none"); // retire outline for focus element
          $selector.data("alreadyOpen", true);
        });

        $("body").on("blur", options.idElem, function (e) {
          e.preventDefault();

          var hasClassOnTarget = options.selector.substring(1, options.selector.length)

          if ($(options.idElem).is(':hover')) {
            return;
          }

          base.hidePopinAndLayer(el, options);

          if (options.toggle) {
            $selector.data("alreadyOpen", false);
          }
        });

      }
    },
    /*
    GenerateLayer()
    Method generate a Layer for popin mode
    */
    generateLayer: function (el, options) {
      var hVar;

      if ($(this.layerID).length < 1) { // Generate Layer

        hVar = this.getMaxHeight();

        $("body").prepend('<div id="' + options.idLayer + '"></div>');

        $(this.layerID).css({
          "zIndex": 9999,
          "background": options.backgroundLayerColor,
          //"opacity": "0.8",
          "height": hVar + "px",
          "width": "100%",
          "position": "absolute",
          "top": 0,
          "left": 0,
          "display": "none"
        });
      }

      if (options.ajaxMode && $("#Ajaxloading").length < 1) {
        if (options.modeView !== "layer") {
          if (options.ajaxLoaderLink !== "") {
            $("body").prepend("<img src='" + options.ajaxLoaderLink + "' alt='loader' id='Ajaxloading' />");
            $("#Ajaxloading").css(
              {
                "zIndex": 10000,
                "position": "absolute",
                "top": 0,
                "left": 0,
                "display": "none"
              }
            );
          }
        }
      }

    },
    /*
    generateContainer()
    Method generate a container for manipulate popin or layer
    */
    generateContainer: function (el, options) {

      var divCreated, imgSrcLoader, idTarget;

      divCreated = this.generatedId(options); // generate ID
      imgSrcLoader = options.ajaxLoaderLink;
      options.idElem = "#" + divCreated;

      if ($(options.idElem).length < 1) {

        // on détecte que c'est la première ouverture de popin
        $(el).data("alreadyCreate", false);

        // on génère le conteneur de la popin
        $("body").prepend('<div id="' + divCreated + '" tabindex="-1"></div>');

        $(options.idElem).css( // Setter default css of pop-in
          {
            "z-index": options.zIndex,
            "position": "absolute",
            "top": "0",
            "left": "-999em",
            "visibility": "hidden"
          }
        );

        if (options.classContainer !== "")
          $(options.idElem).addClass(options.classContainer);

        if (options.targetContent !== "" && options.idElem !== "") {
          $(options.targetContent).prependTo(options.idElem);
        } else {
          console.error(new Error("WARNING : Can't work ! TargetContent or ID automaticaly generated are empty"));
          return;
        }

        // Remove ".hide" class
        $(options.idElem).children().addBack().removeClass('hide');

        this.popinPosition(el, options);

        if (options.modeView !== "layer") { // Pop-In Mode

          $(options.idElem).css("display", "none");

          // Attach event for position popin with resize window
          window.onresize = function () {
            base.popinPosition(el, options);
          };

        } else { // Layer mode : Generate ajax loader in layer

          if (options.ajaxMode && $("#AjaxloadingLayer").length < 1 && imgSrcLoader !== "") {
            $(options.idElem).prepend("<img src='" + imgSrcLoader + "' alt='loader' id='AjaxloadingLayer' />");
            $("#AjaxloadingLayer").css(
              {
                "z-index": "1000",
                "margin": "0 auto",
                "display": "none"
              }
            );
          }

          if (options.outerClose)
            base.bindFocusBlurEvents(el, options); // bind events focus/blur after create

        }

        // Callback method after create Popin/Layer
        options.callbackMethodAfterCreate(el, base, options);

      } else {
        $(el).data("alreadyCreate", true);

        $(options.idElem).children().addBack().removeClass('hide');
      }


    },
    /*
    popinPosition()
    Method enable calculate position of container in page
    Enable relative position for Layer Mode
    */
    popinPosition: function (el, opts) {

      var popin = $(opts.idElem), pos, wPopin, hPopin, positionWindowY, objPosition, posTrigger, realPosTop, realPosLeft, prop;

      if (!opts.customPosition) {
        pos = { top: 0, left: 0 };
        wPopin = popin.outerWidth();
        hPopin = popin.outerHeight();

        if (wPopin !== 0 && hPopin !== 0) {

          positionWindowY = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;

          if (opts.scrollPopin) // in fixed position, relative at window, not document !
            positionWindowY = 0;

          pos.left = parseInt(($(window).width() - wPopin) / 2, 10);
          pos.top = parseInt((($(window).height() - hPopin) / 2) + positionWindowY, 10);

          if (!opts.fullscreen) {
            if (pos.top < 30)
              pos.top = 30;
          } else {
            if (pos.top < 0)
              pos.top = 0;
          }

          // Set obj position
          popin.css({
            "top": pos.top,
            "left": pos.left
          });
        }

        if (opts.scrollPopin) {
          popin.css("position", "fixed");
        }

      } else {
        objPosition = opts.relativePosition;
        posTrigger = $(el).offset();
        realPosTop = parseInt(posTrigger.top + 20, 10);
        realPosLeft = posTrigger.left;

        if (objPosition.left !== -1) {
          for (prop in objPosition) {
            switch (prop) {
              case "left":
                var elWidth = popin.outerWidth(true);
                var viewPortWidth = $(window).outerWidth();
                var triggerWidth = $(el).outerWidth();

                realPosLeft = parseInt(posTrigger.left, 10) - (elWidth * 0.11) + triggerWidth / 2;

                if ((realPosLeft + elWidth) > viewPortWidth) {
                  // 0.89 vient du positionnement CSS de la fleche .bottomRight : left : 89%
                  realPosLeft = parseInt(posTrigger.left, 10) - (elWidth * 0.89) + triggerWidth / 2;

                  if (typeof objPosition.top !== 'undefined' && objPosition.top !== -1) {
                    popin.addClass('f-Utils-arrowBox--topRight');
                  }
                  else if (typeof objPosition.bottom !== 'undefined' && objPosition.bottom !== -1) {
                    popin.addClass('f-Utils-arrowBox--bottomRight');
                  }
                }
                else {
                  popin.removeClass('f-Utils-arrowBox--bottomRight f-Utils-arrowBox--topRight');
                }
                break;

              case "top":
                realPosTop = (objPosition.top > 0) ? parseInt(objPosition.top + realPosTop, 10) : parseInt(realPosTop + objPosition.top, 10);
                break;

              case "right":
                realPosLeft = (objPosition.right > 0) ? parseInt(objPosition.right + realPosLeft, 10) : parseInt(realPosLeft + objPosition.right, 10);
                break;

              case "bottom":
                var elHeight = popin.outerHeight(true);
                var triggerTop = parseInt(posTrigger.top, 10);
                realPosTop = triggerTop - elHeight - objPosition.bottom;
                break;
            }
          }
        }

        popin.css({
          "top": realPosTop,
          "left": realPosLeft
        });
      }

      // Recalculate height layer
      $(this.layerID).height(this.getMaxHeight());

    },
    /*
    * layerLoaderPosition();
    * Method generate layer and loader for multiContent param
    */
    layerLoaderPosition: function () {
      var layer, wL, hL, loader, wLoad, hLoad, posLloader, posHloader, objImg;

      layer = $(base.options.idElem);
      wL = layer.width();
      hL = layer.height();

      if ($("#transparentLayerForLoader").length > 0) {
        $("#transparentLayerForLoader").remove();
      }

      // generate layer for loader in layer
      layer.prepend('<div id="transparentLayerForLoader"></div>');
      $("#transparentLayerForLoader").css({
        "zIndex": 999,
        "background": "#FFF",
        "opacity": "0.5",
        "height": hL + "px",
        "width": "100%",
        "position": "absolute",
        "top": 0,
        "left": 0,
        "display": "none"
      }).show();

      // generate loader in layer
      if ($(".ajaxLoaderStyle", base.options.idElem).length > 0)
        $(".ajaxLoaderStyle", base.options.idElem).remove();

      $(base.options.idElem).prepend('<img src="' + base.options.ajaxLoaderLink + '" alt="loader" id="AjaxloadingLayer" class="ajaxLoaderStyle" />');

      loader = $(".ajaxLoaderStyle");

      // calculate position for loader
      objImg = new Image();
      objImg.src = loader.prop("src");
      wLoad = objImg.width;
      hLoad = objImg.height;
      posLloader = (wL / 2) - (wLoad / 2);
      posHloader = (hL / 2) - (hLoad / 2);

      // positionning loader
      loader.css({
        "zIndex": 1000,
        "margin": "0 auto",
        "display": "block",
        "position": "absolute",
        "top": posHloader + "px",
        "left": posLloader + "px"
      }).show();
      layer.show();
    },
    /*
    showTransparencyLayer()
    Method show transparency Layer under popin
    */
    showTransparencyLayer: function () {
      $(this.layerID).show();
    },
    /*
    hidePopinAndLayer()
    Method hide Popin and Layer and transparency Layer
    */
    hidePopinAndLayer: function (el, options) {
      if (options.idElem !== '') { // if div content has created / if not : just speed hover
        $(options.idElem).hide(); // hide pop-in

        if (options.modeView !== "layer") // hide layer if exist
          $(this.layerID).hide();

        if (options.ajaxLoaderLink !== "") // hide ajax loader
          $("#Ajaxloading").hide();

        if (options.fullscreen)
          $("body").css("overflow", "auto");

        if (options.toggle) {
          $(options.selector).data("alreadyOpen", false);
        }

        options.callbackMethodClose(el, base, options);
      }

      if (options.modeView !== "layer") {
        if (options.bindKeys) {
          $(document).off("keyup");
        }
      }
    },
    /*
    getMaxHeight()
    Method return height of page
    */
    getMaxHeight: function () {
      var max = Math.max($(document).height(), $(window).height(), document.documentElement.clientHeight);
      return max;
    },
    /*
    jsCallBack()
    Method callback integrate response Ajax in popin/layer and show after
    Enable Ajax Fnac (ASPX) with separator in response
    */
    jsCallBack: function (response, options) {
      var target = $(options.targetContent).empty();
      var chars = options.ajaxCharsSplit;
      if (chars && response.indexOf(chars) >= 0) { // Charact detect
        target.append(response.split(chars)[1]);
      } else {
        target.append(response);
      }

      if (!options.customPosition) //
        base.popinPosition(null, options); // Call Positionnement pop-in with content

      $(options.idElem).css("visibility", "visible").show();

      base.options.callbackMethod(target, base, options); // Call options Callback Method after Ajax Call

      base.hideAjaxLoader(); // hide loader
    },
    /*
    viewAjaxLoader()
    Method positioning and show ajaxLoader for popin
    */
    viewAjaxLoader: function () {
      var loader, pos, wPopin, hPopin;
      loader = $("#Ajaxloading");
      pos = { top: 0, left: 0 };
      wPopin = loader.width();
      hPopin = loader.height();

      var positionWindowY = window.scrollY || window.pageYOffset;

      pos.left = parseInt(($(window).width() - wPopin) / 2, 10);
      pos.top = parseInt((($(window).height() - hPopin) / 2) + positionWindowY, 10);

      loader.css({
        top: pos.top,
        left: pos.left
      }).show();
    },
    /*
        showPopinContent()
    */
    showPopinContent: function (el, options) {
      if (options.ajaxMode && !$(el).data("alreadyCreate")) {
        if (options.modeView !== "layer")
          this.viewAjaxLoader();
        else
          $("#AjaxloadingLayer," + options.idElem).css("display", "block");

        this.popinPosition(el, options);

        if (!options.multiContent)
          options.ajaxMethod(el, this, options);

      } else {
        $(options.idElem).css("visibility", "visible").show();
      }

      if (options.multiContent && options.ajaxMode) { // Multi contenu et requete ajax
        var imgSrcLoader = options.ajaxLoaderLink;
        if (imgSrcLoader !== "") {
          if (options.modeView === "layer")
            this.layerLoaderPosition(); // generate Layer and Loader

          if (options.modeView === "popin")
            this.viewAjaxLoader();
        }
        options.ajaxMethod(el, this, options);
      }

    },
    /*
    hideAjaxLoader()
    Method hide ajax Loader
    */
    hideAjaxLoader: function (options) {
      $("#Ajaxloading, #AjaxloadingLayer, #transparentLayerForLoader").hide();
    },
    /*
    generatedID()
    Method generate ID with css class start open popin/layer
    */
    generatedId: function (options) {
      return options.prefixID + options.targetContent.substring(1);
    },
    /*
    hideClassControl();
    Method verifying if container popin has class .ide
    */
    hideClassControl: function () {
      $(this.options.targetContent).addClass("hide");
    }
    };

  $.fn[pluginName] = function (options) {
    options.selector = options.selector || $(this).selector || $(this);

    var $element = $(options.selector);
    if ($element.length) {
      $element.data("popinManager", new Plugin(options));
    }

    return this;
  };
